import { Auth, connectAuthEmulator, getAuth } from "firebase/auth";

import { logMessage } from "shared/services/ErrorReporting";
import { app } from "./app";

export const auth: Auth = getAuth(app);

auth.tenantId = import.meta.env.VITE_FIREBASE_AUTH_TENANT_ID || null;

if (import.meta.env.VITE_USE_FIREBASE_EMULATOR === "true") {
  connectAuthEmulator(
    auth,
    `http://${import.meta.env.VITE_FIREBASE_EMULATOR_HOST}:${import.meta.env.VITE_FIREBASE_EMULATOR_AUTH_PORT}`,
  );
  logMessage("Auth emulator connected");
}
